module.exports = require("core-js/library/fn/object/set-prototype-of");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/core-js/object/set-prototype-of.js
// module id = 265
// module chunks = 168707334958949